/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthenticatedAddMyCompanyRouteImport } from './routes/_authenticated/addMyCompany'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginMagicRouteImport } from './routes/_auth/login-magic'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthAcceptInviteRouteImport } from './routes/_auth/accept-invite'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppTranslationsRouteImport } from './routes/_app/translations'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppDocumentsRouteImport } from './routes/_app/documents'
import { Route as AppDevicesRouteImport } from './routes/_app/devices'
import { Route as AppDeviceAssignmentRouteImport } from './routes/_app/device-assignment'
import { Route as AppCompaniesRouteImport } from './routes/_app/companies'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app/documents/index'
import { Route as AppDevicesIndexRouteImport } from './routes/_app/devices/index'
import { Route as AppDeviceModelsIndexRouteImport } from './routes/_app/device-models/index'
import { Route as AppDevicesDeviceIdRouteImport } from './routes/_app/devices/$deviceId'
import { Route as AppAppsAppSlugRouteImport } from './routes/_app/apps/$appSlug'
import { Route as AppAdminCompaniRouteImport } from './routes/_app/admin/compani'
import { Route as AppDevicesDeviceIdIndexRouteImport } from './routes/_app/devices/$deviceId/index'
import { Route as AppDocumentsFoldersFolderIdRouteImport } from './routes/_app/documents/folders/$folderId'
import { Route as AppDevicesDeviceIdRulesRouteImport } from './routes/_app/devices/$deviceId/rules'
import { Route as AppDevicesDeviceIdOverviewRouteImport } from './routes/_app/devices/$deviceId/overview'
import { Route as AppDevicesDeviceIdAssignmentRouteImport } from './routes/_app/devices/$deviceId/assignment'
import { Route as AppDeviceModelsModelIdFirmwareRouteImport } from './routes/_app/device-models/$modelId/firmware'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthenticatedAddMyCompanyRoute =
  AuthenticatedAddMyCompanyRouteImport.update({
    id: '/addMyCompany',
    path: '/addMyCompany',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginMagicRoute = AuthLoginMagicRouteImport.update({
  id: '/login-magic',
  path: '/login-magic',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptInviteRoute = AuthAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => AuthRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTranslationsRoute = AppTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesRoute = AppDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppDeviceAssignmentRoute = AppDeviceAssignmentRouteImport.update({
  id: '/device-assignment',
  path: '/device-assignment',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesRoute = AppCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDocumentsRoute,
} as any)
const AppDevicesIndexRoute = AppDevicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDevicesRoute,
} as any)
const AppDeviceModelsIndexRoute = AppDeviceModelsIndexRouteImport.update({
  id: '/device-models/',
  path: '/device-models/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesDeviceIdRoute = AppDevicesDeviceIdRouteImport.update({
  id: '/$deviceId',
  path: '/$deviceId',
  getParentRoute: () => AppDevicesRoute,
} as any)
const AppAppsAppSlugRoute = AppAppsAppSlugRouteImport.update({
  id: '/apps/$appSlug',
  path: '/apps/$appSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminCompaniRoute = AppAdminCompaniRouteImport.update({
  id: '/admin/compani',
  path: '/admin/compani',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesDeviceIdIndexRoute = AppDevicesDeviceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDevicesDeviceIdRoute,
} as any)
const AppDocumentsFoldersFolderIdRoute =
  AppDocumentsFoldersFolderIdRouteImport.update({
    id: '/folders/$folderId',
    path: '/folders/$folderId',
    getParentRoute: () => AppDocumentsRoute,
  } as any)
const AppDevicesDeviceIdRulesRoute = AppDevicesDeviceIdRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppDevicesDeviceIdRoute,
} as any)
const AppDevicesDeviceIdOverviewRoute =
  AppDevicesDeviceIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppDevicesDeviceIdRoute,
  } as any)
const AppDevicesDeviceIdAssignmentRoute =
  AppDevicesDeviceIdAssignmentRouteImport.update({
    id: '/assignment',
    path: '/assignment',
    getParentRoute: () => AppDevicesDeviceIdRoute,
  } as any)
const AppDeviceModelsModelIdFirmwareRoute =
  AppDeviceModelsModelIdFirmwareRouteImport.update({
    id: '/device-models/$modelId/firmware',
    path: '/device-models/$modelId/firmware',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/companies': typeof AppCompaniesRoute
  '/device-assignment': typeof AppDeviceAssignmentRoute
  '/devices': typeof AppDevicesRouteWithChildren
  '/documents': typeof AppDocumentsRouteWithChildren
  '/profile': typeof AppProfileRoute
  '/translations': typeof AppTranslationsRoute
  '/users': typeof AppUsersRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/login': typeof AuthLoginRoute
  '/login-magic': typeof AuthLoginMagicRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/addMyCompany': typeof AuthenticatedAddMyCompanyRoute
  '/admin/compani': typeof AppAdminCompaniRoute
  '/apps/$appSlug': typeof AppAppsAppSlugRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRouteWithChildren
  '/device-models/': typeof AppDeviceModelsIndexRoute
  '/devices/': typeof AppDevicesIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/device-models/$modelId/firmware': typeof AppDeviceModelsModelIdFirmwareRoute
  '/devices/$deviceId/assignment': typeof AppDevicesDeviceIdAssignmentRoute
  '/devices/$deviceId/overview': typeof AppDevicesDeviceIdOverviewRoute
  '/devices/$deviceId/rules': typeof AppDevicesDeviceIdRulesRoute
  '/documents/folders/$folderId': typeof AppDocumentsFoldersFolderIdRoute
  '/devices/$deviceId/': typeof AppDevicesDeviceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/companies': typeof AppCompaniesRoute
  '/device-assignment': typeof AppDeviceAssignmentRoute
  '/profile': typeof AppProfileRoute
  '/translations': typeof AppTranslationsRoute
  '/users': typeof AppUsersRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/login': typeof AuthLoginRoute
  '/login-magic': typeof AuthLoginMagicRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/addMyCompany': typeof AuthenticatedAddMyCompanyRoute
  '/admin/compani': typeof AppAdminCompaniRoute
  '/apps/$appSlug': typeof AppAppsAppSlugRoute
  '/device-models': typeof AppDeviceModelsIndexRoute
  '/devices': typeof AppDevicesIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/device-models/$modelId/firmware': typeof AppDeviceModelsModelIdFirmwareRoute
  '/devices/$deviceId/assignment': typeof AppDevicesDeviceIdAssignmentRoute
  '/devices/$deviceId/overview': typeof AppDevicesDeviceIdOverviewRoute
  '/devices/$deviceId/rules': typeof AppDevicesDeviceIdRulesRoute
  '/documents/folders/$folderId': typeof AppDocumentsFoldersFolderIdRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_app/companies': typeof AppCompaniesRoute
  '/_app/device-assignment': typeof AppDeviceAssignmentRoute
  '/_app/devices': typeof AppDevicesRouteWithChildren
  '/_app/documents': typeof AppDocumentsRouteWithChildren
  '/_app/profile': typeof AppProfileRoute
  '/_app/translations': typeof AppTranslationsRoute
  '/_app/users': typeof AppUsersRoute
  '/_auth/accept-invite': typeof AuthAcceptInviteRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/login-magic': typeof AuthLoginMagicRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_authenticated/addMyCompany': typeof AuthenticatedAddMyCompanyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/compani': typeof AppAdminCompaniRoute
  '/_app/apps/$appSlug': typeof AppAppsAppSlugRoute
  '/_app/devices/$deviceId': typeof AppDevicesDeviceIdRouteWithChildren
  '/_app/device-models/': typeof AppDeviceModelsIndexRoute
  '/_app/devices/': typeof AppDevicesIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/device-models/$modelId/firmware': typeof AppDeviceModelsModelIdFirmwareRoute
  '/_app/devices/$deviceId/assignment': typeof AppDevicesDeviceIdAssignmentRoute
  '/_app/devices/$deviceId/overview': typeof AppDevicesDeviceIdOverviewRoute
  '/_app/devices/$deviceId/rules': typeof AppDevicesDeviceIdRulesRoute
  '/_app/documents/folders/$folderId': typeof AppDocumentsFoldersFolderIdRoute
  '/_app/devices/$deviceId/': typeof AppDevicesDeviceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/companies'
    | '/device-assignment'
    | '/devices'
    | '/documents'
    | '/profile'
    | '/translations'
    | '/users'
    | '/accept-invite'
    | '/login'
    | '/login-magic'
    | '/register'
    | '/reset-password'
    | '/set-password'
    | '/addMyCompany'
    | '/admin/compani'
    | '/apps/$appSlug'
    | '/devices/$deviceId'
    | '/device-models/'
    | '/devices/'
    | '/documents/'
    | '/device-models/$modelId/firmware'
    | '/devices/$deviceId/assignment'
    | '/devices/$deviceId/overview'
    | '/devices/$deviceId/rules'
    | '/documents/folders/$folderId'
    | '/devices/$deviceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/companies'
    | '/device-assignment'
    | '/profile'
    | '/translations'
    | '/users'
    | '/accept-invite'
    | '/login'
    | '/login-magic'
    | '/register'
    | '/reset-password'
    | '/set-password'
    | '/addMyCompany'
    | '/admin/compani'
    | '/apps/$appSlug'
    | '/device-models'
    | '/devices'
    | '/documents'
    | '/device-models/$modelId/firmware'
    | '/devices/$deviceId/assignment'
    | '/devices/$deviceId/overview'
    | '/devices/$deviceId/rules'
    | '/documents/folders/$folderId'
    | '/devices/$deviceId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_authenticated'
    | '/_app/companies'
    | '/_app/device-assignment'
    | '/_app/devices'
    | '/_app/documents'
    | '/_app/profile'
    | '/_app/translations'
    | '/_app/users'
    | '/_auth/accept-invite'
    | '/_auth/login'
    | '/_auth/login-magic'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_auth/set-password'
    | '/_authenticated/addMyCompany'
    | '/_app/'
    | '/_app/admin/compani'
    | '/_app/apps/$appSlug'
    | '/_app/devices/$deviceId'
    | '/_app/device-models/'
    | '/_app/devices/'
    | '/_app/documents/'
    | '/_app/device-models/$modelId/firmware'
    | '/_app/devices/$deviceId/assignment'
    | '/_app/devices/$deviceId/overview'
    | '/_app/devices/$deviceId/rules'
    | '/_app/documents/folders/$folderId'
    | '/_app/devices/$deviceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_authenticated/addMyCompany': {
      id: '/_authenticated/addMyCompany'
      path: '/addMyCompany'
      fullPath: '/addMyCompany'
      preLoaderRoute: typeof AuthenticatedAddMyCompanyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-magic': {
      id: '/_auth/login-magic'
      path: '/login-magic'
      fullPath: '/login-magic'
      preLoaderRoute: typeof AuthLoginMagicRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accept-invite': {
      id: '/_auth/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AuthAcceptInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/translations': {
      id: '/_app/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof AppTranslationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices': {
      id: '/_app/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AppDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/device-assignment': {
      id: '/_app/device-assignment'
      path: '/device-assignment'
      fullPath: '/device-assignment'
      preLoaderRoute: typeof AppDeviceAssignmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies': {
      id: '/_app/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AppCompaniesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppDocumentsRoute
    }
    '/_app/devices/': {
      id: '/_app/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof AppDevicesIndexRouteImport
      parentRoute: typeof AppDevicesRoute
    }
    '/_app/device-models/': {
      id: '/_app/device-models/'
      path: '/device-models'
      fullPath: '/device-models/'
      preLoaderRoute: typeof AppDeviceModelsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/$deviceId': {
      id: '/_app/devices/$deviceId'
      path: '/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof AppDevicesDeviceIdRouteImport
      parentRoute: typeof AppDevicesRoute
    }
    '/_app/apps/$appSlug': {
      id: '/_app/apps/$appSlug'
      path: '/apps/$appSlug'
      fullPath: '/apps/$appSlug'
      preLoaderRoute: typeof AppAppsAppSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/compani': {
      id: '/_app/admin/compani'
      path: '/admin/compani'
      fullPath: '/admin/compani'
      preLoaderRoute: typeof AppAdminCompaniRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/$deviceId/': {
      id: '/_app/devices/$deviceId/'
      path: '/'
      fullPath: '/devices/$deviceId/'
      preLoaderRoute: typeof AppDevicesDeviceIdIndexRouteImport
      parentRoute: typeof AppDevicesDeviceIdRoute
    }
    '/_app/documents/folders/$folderId': {
      id: '/_app/documents/folders/$folderId'
      path: '/folders/$folderId'
      fullPath: '/documents/folders/$folderId'
      preLoaderRoute: typeof AppDocumentsFoldersFolderIdRouteImport
      parentRoute: typeof AppDocumentsRoute
    }
    '/_app/devices/$deviceId/rules': {
      id: '/_app/devices/$deviceId/rules'
      path: '/rules'
      fullPath: '/devices/$deviceId/rules'
      preLoaderRoute: typeof AppDevicesDeviceIdRulesRouteImport
      parentRoute: typeof AppDevicesDeviceIdRoute
    }
    '/_app/devices/$deviceId/overview': {
      id: '/_app/devices/$deviceId/overview'
      path: '/overview'
      fullPath: '/devices/$deviceId/overview'
      preLoaderRoute: typeof AppDevicesDeviceIdOverviewRouteImport
      parentRoute: typeof AppDevicesDeviceIdRoute
    }
    '/_app/devices/$deviceId/assignment': {
      id: '/_app/devices/$deviceId/assignment'
      path: '/assignment'
      fullPath: '/devices/$deviceId/assignment'
      preLoaderRoute: typeof AppDevicesDeviceIdAssignmentRouteImport
      parentRoute: typeof AppDevicesDeviceIdRoute
    }
    '/_app/device-models/$modelId/firmware': {
      id: '/_app/device-models/$modelId/firmware'
      path: '/device-models/$modelId/firmware'
      fullPath: '/device-models/$modelId/firmware'
      preLoaderRoute: typeof AppDeviceModelsModelIdFirmwareRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppDevicesDeviceIdRouteChildren {
  AppDevicesDeviceIdAssignmentRoute: typeof AppDevicesDeviceIdAssignmentRoute
  AppDevicesDeviceIdOverviewRoute: typeof AppDevicesDeviceIdOverviewRoute
  AppDevicesDeviceIdRulesRoute: typeof AppDevicesDeviceIdRulesRoute
  AppDevicesDeviceIdIndexRoute: typeof AppDevicesDeviceIdIndexRoute
}

const AppDevicesDeviceIdRouteChildren: AppDevicesDeviceIdRouteChildren = {
  AppDevicesDeviceIdAssignmentRoute: AppDevicesDeviceIdAssignmentRoute,
  AppDevicesDeviceIdOverviewRoute: AppDevicesDeviceIdOverviewRoute,
  AppDevicesDeviceIdRulesRoute: AppDevicesDeviceIdRulesRoute,
  AppDevicesDeviceIdIndexRoute: AppDevicesDeviceIdIndexRoute,
}

const AppDevicesDeviceIdRouteWithChildren =
  AppDevicesDeviceIdRoute._addFileChildren(AppDevicesDeviceIdRouteChildren)

interface AppDevicesRouteChildren {
  AppDevicesDeviceIdRoute: typeof AppDevicesDeviceIdRouteWithChildren
  AppDevicesIndexRoute: typeof AppDevicesIndexRoute
}

const AppDevicesRouteChildren: AppDevicesRouteChildren = {
  AppDevicesDeviceIdRoute: AppDevicesDeviceIdRouteWithChildren,
  AppDevicesIndexRoute: AppDevicesIndexRoute,
}

const AppDevicesRouteWithChildren = AppDevicesRoute._addFileChildren(
  AppDevicesRouteChildren,
)

interface AppDocumentsRouteChildren {
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppDocumentsFoldersFolderIdRoute: typeof AppDocumentsFoldersFolderIdRoute
}

const AppDocumentsRouteChildren: AppDocumentsRouteChildren = {
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppDocumentsFoldersFolderIdRoute: AppDocumentsFoldersFolderIdRoute,
}

const AppDocumentsRouteWithChildren = AppDocumentsRoute._addFileChildren(
  AppDocumentsRouteChildren,
)

interface AppRouteChildren {
  AppCompaniesRoute: typeof AppCompaniesRoute
  AppDeviceAssignmentRoute: typeof AppDeviceAssignmentRoute
  AppDevicesRoute: typeof AppDevicesRouteWithChildren
  AppDocumentsRoute: typeof AppDocumentsRouteWithChildren
  AppProfileRoute: typeof AppProfileRoute
  AppTranslationsRoute: typeof AppTranslationsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminCompaniRoute: typeof AppAdminCompaniRoute
  AppAppsAppSlugRoute: typeof AppAppsAppSlugRoute
  AppDeviceModelsIndexRoute: typeof AppDeviceModelsIndexRoute
  AppDeviceModelsModelIdFirmwareRoute: typeof AppDeviceModelsModelIdFirmwareRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCompaniesRoute: AppCompaniesRoute,
  AppDeviceAssignmentRoute: AppDeviceAssignmentRoute,
  AppDevicesRoute: AppDevicesRouteWithChildren,
  AppDocumentsRoute: AppDocumentsRouteWithChildren,
  AppProfileRoute: AppProfileRoute,
  AppTranslationsRoute: AppTranslationsRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminCompaniRoute: AppAdminCompaniRoute,
  AppAppsAppSlugRoute: AppAppsAppSlugRoute,
  AppDeviceModelsIndexRoute: AppDeviceModelsIndexRoute,
  AppDeviceModelsModelIdFirmwareRoute: AppDeviceModelsModelIdFirmwareRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAcceptInviteRoute: typeof AuthAcceptInviteRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLoginMagicRoute: typeof AuthLoginMagicRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcceptInviteRoute: AuthAcceptInviteRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLoginMagicRoute: AuthLoginMagicRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAddMyCompanyRoute: typeof AuthenticatedAddMyCompanyRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAddMyCompanyRoute: AuthenticatedAddMyCompanyRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
